





import Vue from 'vue';
import { ProdejNovychVozu } from '@/modules/noveVozy/prodejNovychVozu';
import { genVuexComputeds } from '@/main/pages/editFactory';

import { types } from '../../store/types';
import { store } from '../../store/edit';

export default Vue.extend({
	name: 'ZakazkaPnvSelect',
	components: {
		PnvSelect: ProdejNovychVozu.components.Select,
	},
	props: {
		storeUri: { type: String, default: null, required: true },
	},
	computed: {
		...genVuexComputeds(store),
		mutationsMappers(): Record<string, string> {
			return {
				mutationName: `${this.storeUri}/${types.mutations.ZAKAZKA_PNV_SELECT_MAPPER}`,
			};
		},
		actionsMapper(): Record<string, string> {
			return {
				actionName: `${this.storeUri}/${types.actions.ZAKAZKA_PNV_CHANGE}`,
			};
		},
		pnvSelectFilter(): object {
			return {
				PnvNr: this.PnvNr,
			};
		},
	},
});
